import { Subject } from 'rxjs';
/**
 * serviceBus 通讯服务器端，用来监听其他子应用发来的请求
 *
 * @export
 */
export class ServiceBusServer {
    /**
     * Creates an instance of ServiceBusServer.
     * @param  appName server所在应用名称
     * @param  serviceBusService serviceBusServer
     */
    constructor(appName, serviceBusService) {
        this._events = new Subject();
        this._serviceBus = serviceBusService;
        this.appName = appName;
    }
    /**
     * 应用的事件
     *
     */
    get events() {
        return this._events;
    }
    /**
     * 注册server
     *
     */
    register() {
        this._serviceBus.registerServer(this);
    }
    /**
     * 发布事件
     *
     */
    publishEvent(event) {
        this._events.next(event);
    }
    /**
     * 销毁
     *
     */
    destroy() {
        this.requestHandler = null;
        this._events.error('destroyed');
    }
}
